import React from 'react';
import classnames from 'classnames';
const OnContent = ({ isOn = false, children, isFilterBar = false, }) => isFilterBar ? React.Children.map(children, child => (<li>{child}</li>)) : (<div className={classnames({ hidden: !isOn })}>{children}</div>);
export default OnContent;
